import {
  Link,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import type { SpofCard } from "../types";
import { sar } from "../utils/format";
import { mitigationHref } from "../utils/links";
import { TimelineChip } from "./Chips";
import DashboardCard from "./DashboardCard";
import { PendingCardBody, PendingValue } from "./PendingValue";

export default function SpofMitigationsCard({ spof }: { spof: SpofCard }) {
  return (
    <DashboardCard title="Mitigation & Residual Risk">
      {spof.mitigations.length === 0 ? (
        <PendingCardBody hint="No mitigation is proposed for this SPOF yet." />
      ) : (
        <Table size="small">
          <TableHead>
            <TableRow>
              {[
                "Mitigation ID",
                "Mitigation Short Description",
                "Department",
                "Implementation Timeline",
              ].map((label) => (
                <TableCell key={label} sx={{ fontWeight: 600 }}>
                  {label}
                </TableCell>
              ))}
              {["CAPEX", "OPEX"].map((label) => (
                <TableCell key={label} align="right" sx={{ fontWeight: 600 }}>
                  {label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {spof.mitigations.map((mitigation, index) => (
              <TableRow key={mitigation.mitigation_id ?? index} hover>
                <TableCell sx={{ whiteSpace: "nowrap" }}>
                  {mitigation.mitigation_id ?? <PendingValue />}
                </TableCell>
                <TableCell>
                  {mitigation.mitigation_id ? (
                    <Link
                      href={mitigationHref(
                        spof.power_plant_id,
                        spof.spof_id,
                        mitigation.mitigation_id,
                      )}
                      underline="hover"
                    >
                      {mitigation.mitigation_short ?? mitigation.mitigation_id}
                    </Link>
                  ) : (
                    (mitigation.mitigation_short ?? <PendingValue />)
                  )}
                </TableCell>
                <TableCell>{spof.section ?? <PendingValue />}</TableCell>
                <TableCell>
                  <TimelineChip phase={mitigation.implementation_phase} />
                </TableCell>
                <TableCell align="right" sx={{ whiteSpace: "nowrap" }}>
                  {mitigation.estimated_gbl_capex_sar === null ? (
                    <PendingValue />
                  ) : (
                    sar(mitigation.estimated_gbl_capex_sar)
                  )}
                </TableCell>
                <TableCell align="right" sx={{ whiteSpace: "nowrap" }}>
                  {mitigation.estimated_se_opex_sar === null ? (
                    <PendingValue />
                  ) : (
                    sar(mitigation.estimated_se_opex_sar, true)
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </DashboardCard>
  );
}
